module.exports = __webpack_public_path__ + "img/hand-point-ribbon.73d562c6.svg";